/**
 *
 * SectionFields
 *
 */
import React, { memo, useMemo } from 'react';
import classNames from 'classnames';

// antd component
import { Form, Input } from 'antd';
const { TextArea } = Input;

function SectionFields({
  name,
  sectionValues,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('tcf-fb-field-row', className);

  const sectionTitle = useMemo(() => (
    <Form.Item
      name={[name, `${name}-title`]}
      fieldKey={[name, `${name}-title`]}
      rules={[
        {
          required: true,
          message: 'Champ obligatoire',
        },
      ]}
      label="Titre du formulaire"
      className="input"
    >
      <Input
        placeholder={`Titre du formulaire`}
      />
    </Form.Item>
  ), [name, sectionValues]);

  const sectionDescription = useMemo(() => (
    <Form.Item
      name={[name, `${name}-description`]}
      fieldKey={[name, `${name}-description`]}
      rules={[
        {
          type: 'string',
          min: 6,
          message: 'Minimum 6 caractères requis'
        }
      ]}
      label="Description"
      className="textarea"
    >
      <TextArea
        rows={4}
        placeholder="Description (optionel)" minLength={6} />
    </Form.Item>
  ), [name]);

  return name && (
    <div className={childClassNames}>
      {sectionTitle}
      {sectionDescription}
    </div>
  );
};

SectionFields.defaultProps = {};

export default memo(SectionFields);